import { cx } from "../../Utils/helpers";

/**
 * Width-constrained wrapper. Use `as` to keep semantics correct
 * (e.g. <Container as="header">) instead of nesting extra divs.
 */
function Container({ children, size = "default", as: Tag = "div", className, ...rest }) {
  const sizeClass = size === "narrow" ? "container--narrow" : size === "wide" ? "container--wide" : "";

  return (
    <Tag className={cx("container", sizeClass, className)} {...rest}>
      {children}
    </Tag>
  );
}

export default Container;
